import React, { useContext } from 'react';
import { withRouter, useHistory } from 'react-router-dom';
import { Button, TipCard } from '../../components';
import { icons } from '../../assets';
import * as s from './styled-forgot-password-verify';
import { ThemeContext } from 'styled-components';

const RecuperarSenhaResposta = () => {

  const { colors } = useContext(ThemeContext);
  const history = useHistory();

  const onSubmit = () => {
    history.push('/reset-password')
  };

  return (
    <s.Column>
      <TipCard icon={icons.KeyImageBackground} />
      <s.Cmodel onSubmit={onSubmit}>

        <s.WrapperTitle>
          <s.Label color={colors.darkblue}>Recuperar Senha</s.Label>
        </s.WrapperTitle>
        <s.Label size="18px" color={colors.label}>
          Verifique a caixa de entrada de seu email para <br /> cadastrar uma nova senha.
        </s.Label >
        <s.ButtonContainer margin="100px 0 0 0">
          <Button
            type="submit"
            width="45vw"
            maxWidth='450px'
            label="Confirmar"
            hover
            color={colors.darkblue}
            background={colors.white}
          />
        </s.ButtonContainer>
      </s.Cmodel>
      <div style={{ width: '183px' }} />
    </s.Column>
  );
};

export default withRouter(RecuperarSenhaResposta);
